import { isDevLikeEnv } from "@crystal/config";
import { glassConfig } from "@crystal/glass-bridge";
function getRedirectUrl(method, context, isAuthProvider) {
  const { brand, locale, env } = context;
  if (isAuthProvider) {
    const envPrefix = env === "prod" ? "" : "stg.";
    const origin = `https://${envPrefix}account-frontends.adidas.com`;
    return `${origin}/external-auth`;
  }
  let { siteUrl } = glassConfig.evaluateWithContext(context);
  const appPath = method === "social-login" ? "/social-login" : "/ext-auth";
  if (method === "social-login" && isDevLikeEnv(env)) {
    siteUrl = glassConfig.evaluateWithContext({ brand, locale, env: "dev" }).siteUrl;
  }
  if (method === "kmc" && isDevLikeEnv(env)) {
    siteUrl = glassConfig.evaluateWithContext({ brand, locale, env: "stg" }).siteUrl;
  }
  return `${siteUrl}${appPath}`;
}
export {
  getRedirectUrl
};
//# sourceMappingURL=utils.js.map
